import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { SportType } from "../../../models/court/dto/court.dto";
import { GetCurrentUserOutputDto } from "../../../models/user/dto/get-current-user.dto";
import { GET_USER_BY_ID_QUERY_KEY } from "./useGetUser";

export const useValidateSportLevelIdentification = (id: string, onSuccess?: (data: GetCurrentUserOutputDto) => void) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['validateSportLevelIdentification', id],
        mutationFn: (input: { sportType: SportType; isIdentificationVerified: boolean }) => {
            const endpoint = `users/${id}/sport-level/${encodeURIComponent(input.sportType)}/validate-identification`;
            return client.fetchApi<GetCurrentUserOutputDto, { isIdentificationVerified: boolean }>({
                endpoint,
                method: 'POST',
                body: { isIdentificationVerified: input.isIdentificationVerified },
            });
        },
        onSuccess: (data) => {
            queryClient.setQueryData(GET_USER_BY_ID_QUERY_KEY(id), () => data);
            onSuccess?.(data);
        }
    });
};
